import ClearhausLogoFull from './ClearhausLogoFull';

const LogoFull = ClearhausLogoFull;

export default LogoFull;
